// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1ntyy","icon":"SortAdornment_icon__3Rga3","up":"SortAdornment_up__1P1S-","down":"SortAdornment_down__3BwBn","active":"SortAdornment_active__1aq0m"};